module.exports = __webpack_public_path__ + "media/images/icon/icons8-Installing Updates-249314dbe255626b08e1a7fd6466118c.png";